import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useI18n } from "../i18n/LanguageContext";
import { useSeo } from "../hooks/useSeo";

export default function NotFound() {
  const { t, lang } = useI18n();
  useSeo({ title: t.notFound.title, description: t.notFound.description, path: "/404", lang });

  return (
    <section className="container-wide py-24 md:py-32" data-testid="not-found">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end">
        <div className="lg:col-span-12 flex items-center justify-between gap-6">
          <p className="eyebrow">404</p>
          <p className="hidden md:block text-xs uppercase tracking-[0.22em] text-muted-foreground font-bold">{t.common.benelux}</p>
        </div>
        <h1 className="lg:col-span-12 font-display text-[80px] sm:text-[120px] lg:text-[200px] leading-[0.92] tracking-[-0.03em] font-medium text-foreground">
          {t.notFound.headline}
        </h1>
        <div className="lg:col-span-7">
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed max-w-2xl">{t.notFound.body}</p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Link to="/" className="btn-primary" data-testid="notfound-home">
              {t.notFound.backHome} <ArrowUpRight className="h-4 w-4" />
            </Link>
            <Link to="/contact" className="btn-ghost">
              {t.common.contact_us}
            </Link>
          </div>
        </div>
        <aside className="lg:col-span-5">
          <div className="border-t border-border pt-6 space-y-3 max-w-md ml-auto text-sm">
            <Link to="/diensten" className="flex items-baseline justify-between gap-6 border-b border-border pb-3 hover:text-accent transition-colors">
              <span className="font-display text-xl text-foreground">{t.nav.services}</span>
              <ArrowUpRight className="h-3.5 w-3.5" />
            </Link>
            <Link to="/tarieven" className="flex items-baseline justify-between gap-6 border-b border-border pb-3 hover:text-accent transition-colors">
              <span className="font-display text-xl text-foreground">{t.nav.pricing}</span>
              <ArrowUpRight className="h-3.5 w-3.5" />
            </Link>
            <Link to="/dossiers" className="flex items-baseline justify-between gap-6 border-b border-border pb-3 hover:text-accent transition-colors">
              <span className="font-display text-xl text-foreground">{t.nav.cases}</span>
              <ArrowUpRight className="h-3.5 w-3.5" />
            </Link>
            <Link to="/faq" className="flex items-baseline justify-between gap-6 hover:text-accent transition-colors">
              <span className="font-display text-xl text-foreground">{t.nav.faq}</span>
              <ArrowUpRight className="h-3.5 w-3.5" />
            </Link>
          </div>
        </aside>
      </div>
    </section>
  );
}
